export default [
  { value: 'PHT.1438G', label: 'PHT.1438G - GRID Team' },
  {
    value: 'PHT.1692G',
    label: 'PHT.1692G - VicOne Automotive Security PH',
  },
  {
    value: 'PHT.1491G',
    label: 'PHT.1491G - PH Global Response-Escalation Team',
  },
  { value: 'PHT.1492G', label: 'PHT.1492G - PH Global Response-AU Team' },
  { value: 'PHT.1493G', label: 'PHT.1493G - PH Global Response-QA Team' },
  { value: 'PHT.1430G', label: 'PHT.1430G - NTT Operations Team' },
  {
    value: 'PHT.1419G',
    label: 'PHT.1419G - PH Global Response - TAD Operations',
  },
  { value: 'PHT.1437G', label: 'PHT.1437G - Core Tech MKT' },
  { value: 'PHT.1394G', label: 'PHT.1394G - Core Tech- Comms and Social' },
  { value: 'PHT.1691G', label: 'PHT.1691G - Core Tech MKT -JP' },
  { value: 'PHT.1431G', label: 'PHT.1431G - PH Global Response-AV Team' },
  {
    value: 'PHT.1413G',
    label: 'PHT.1413G - PH CoreTech D*Works Cloud Dev Team',
  },
  { value: 'PHT.1742G', label: 'PHT.1742G - PH D*Works' },
  {
    value: 'PHT.1436G',
    label: 'PHT.1436G - PH Core Tech MDR Operation Center',
  },
  { value: 'PHT.1434G', label: 'PHT.1434G - Threat Hunting' },
  { value: 'PHT.1435G', label: 'PHT.1435G - Core Tech Training' },
  { value: 'PHT.1439G', label: 'PHT.1439G - SPOC & Service JM' },
  {
    value: 'PHT.1432G',
    label: 'PHT.1432G - Threat Customer Service Engineering',
  },
  { value: 'PHT.3432G', label: 'PHT.3432G - AMEA R1' },
  { value: 'PHT.3433G', label: 'PHT.3433G - AMEA COE Program' },
  { value: 'PHT.3431E', label: 'PHT.3431E - AMEA R2' },
  { value: 'PHT.1415G', label: 'PHT.1415G - AMEA COE Off Hours' },
  {
    value: 'PHT.1418G',
    label: 'PHT.1418G - Global CSD and Service Engineering',
  },
  { value: 'PHT.1411G', label: 'PHT.1411G - PH Corp Support - General' },
  { value: 'PHT.1412G', label: 'PHT.1412G - Global 24x7 WF & Hosted Services' },
  { value: 'PHT.1412S', label: 'PHT.1412S - tCAM - SB' },
  {
    value: 'PHT.1414G',
    label: 'PHT.1414G - Global 24x7 Support Engineering GSE',
  },
  {
    value: 'PHT.1418G',
    label: 'PHT.1418G - Global CSD and Service Engineering',
  },
  { value: 'PHT.1651G', label: 'PHT.1651G - PH Corp Beta' },
  { value: 'PHT.1417G', label: 'PHT.1417G - TS Engineering Documentation' },
  { value: 'PHT.1161G', label: 'PHT.1161G - CEI / TIE' },
  {
    value: 'PHT.1422G',
    label: 'PHT.1422G - PH Corp Tech Support - Knowledge Base',
  },
  { value: 'PHT.5343C', label: 'PHT.5343C - Technical Product Marketing (PH)' },
  { value: 'PHT.1428G', label: 'PHT.1428G - Global DSaas 24/7 Support' },
  { value: 'PHT.1441G', label: 'PHT.1441G - PH SRE team' },
  {
    value: 'PHT.1412C',
    label: 'PHT.1412C - Consumer Technical Support-Standard Support PH',
  },
  {
    value: 'PHT.1423G',
    label: 'PHT.1423G - Technical Support, Workforce Management PH',
  },
  { value: 'PHT.1443C', label: 'PHT.1443C - PHT Global Consumer Support' },
  {
    value: 'PHT.1452G',
    label: 'PHT.1452G - Consumer Technical Support, Premium ? PH',
  },
  {
    value: 'PHT.5311C',
    label: 'PHT.5311C - PH Consumer Segment - New Products Sales',
  },
  { value: 'PHT.1721G', label: 'PHT.1721G - PH Corp HR' },
  { value: 'PHT.1722G', label: 'PHT.1722G - PH Corp HR - New Graduate' },
  { value: 'PHT.1741G', label: 'PHT.1741G - PH Regional IS' },
  { value: 'PHT.1765G', label: 'PHT.1765G - AMEA BA' },
  { value: 'PHT.1761G', label: 'PHT.1761G - GIS' },
  { value: 'PHT.1762G', label: 'PHT.1762G - GIS' },
  { value: 'PHT.1763G', label: 'PHT.1763G - GIS' },
  { value: 'PHT.1751G', label: 'PHT.1751G - PH Finance' },
  { value: 'PHT.1764G', label: 'PHT.1764G - PH Infosec' },
  { value: 'PHT.1711G', label: 'PHT.1711G - PH Admin' },
  { value: 'PHT.1746G', label: 'PHT.1746G - Global Corp BAS' },
  { value: 'PHT.2211G', label: 'PHT.2211G - PH Sales' },
];
